function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0d0e0e;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-74.54 -73.89)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M90.47,76.362l13.676,8.918v17.411H76.66V85.279L90.47,76.362m0-2.471L74.54,84.184v20.569h31.726V84.183L90.47,73.89Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 23.82,
  height: 1.943,
  transform: "translate(78.428 86.328)"
}), /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 23.82,
  height: 1.943,
  transform: "translate(78.428 96.671)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M123.229,174.482H118.32v-5.9h4.909Zm-3.016-1.893h1.123v-2.117h-1.123Z",
  transform: "translate(-36.325 -79.057)"
}), /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M192.529,174.638H187.62v-5.9h4.909Zm-3.016-1.893h1.123v-2.112h-1.123Z",
  transform: "translate(-93.824 -79.191)"
}));

function SvgIconWohnung(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.726,
    height: 30.863,
    viewBox: "0 0 31.726 30.863",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWohnung);
export default __webpack_public_path__ + "static/media/IconWohnung.31529c25046238c8f053a46372a7320f.svg";
export { ForwardRef as ReactComponent };